import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  alertsContainer: {
    bottom: Theme.px(30),
    left: Theme.px(0),
    right: Theme.px(0),
  },
  bottomContent: {
    bottom: Theme.px(90),
    left: Theme.px(0),
    position: 'absolute',
    right: Theme.px(0),
  },
  changeMapButtonContent: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  changeMapButtonImage: {
    height: Theme.px(28),
    marginRight: Theme.px(15),
    resizeMode: 'contain',
    tintColor: Theme.blackPearlBlue,
    width: Theme.px(28),
  },
  changeMapButtonText: {
    color: Theme.blackPearlBlue,
  },
  map: {
    display: 'flex',
    flex: 1,
  },
  mapAttribution: {
    bottom: Theme.px(30),
    height: Theme.px(40),
    left: Theme.px(90),
    position: 'absolute',
    right: Theme.px(90),
  },
  mapContainer: {
    height: Theme.px(1080),
    width: Theme.px(1920),
  },
  mapControlsContainer: {
    flexDirection: 'row',
    left: Theme.px(90),
    right: Theme.px(90),
  },
  modalContent: {
    bottom: Theme.px(0),
    height: Theme.px(510),
    position: 'absolute',
    width: Theme.px(1920),
  },
});
